import { Theme } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
export const useStyles = makeStyles()((theme: Theme) => ({
  dashboardContainer: {
    width: '100%',
    height: '100%',
  },
}))
